import clsx from 'clsx'
import {
	type FieldsetHTMLAttributes,
	type InputHTMLAttributes,
	useId
} from 'react'
import { a11y, typo } from 'shared/styles'

import css from './Segmented.module.css'

const cn = {
	input: clsx(css.input, a11y.hidden)
}

const Radios = ({
	children,
	className,
	label = 'Tabs',
	...props
}: FieldsetHTMLAttributes<HTMLFieldSetElement> & {
	label?: string
}) => (
	<fieldset className={clsx(className, css.root)} {...props}>
		<legend className={a11y.hidden}>{label}</legend>
		{children}
	</fieldset>
)

function Radio({
	children,
	className,
	...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
	const id = useId()
	return (
		<>
			<input className={cn.input} id={id} type='radio' {...props} />
			<label className={clsx(css.label, typo.buttonSm, className)} htmlFor={id}>
				{children}
			</label>
		</>
	)
}

export { Radio, Radios }
